import type { AppSettings, ScriptDocument } from "./types";

export function normalizeScriptDocument(document: ScriptDocument, defaults: AppSettings): ScriptDocument {
  document.memorisation ??= {};
  document.tags ??= [];
  document.notes ??= "";
  document.settings.selectedCharacterIds ??= [];
  const legacyRevealMode = document.settings.revealMode as string | undefined;
  document.settings.hideMine ??= legacyRevealMode === "hideMine";
  document.settings.hideOthers ??= legacyRevealMode === "hideOthers";
  document.settings.showOtherLinesNormally ??= false;
  if (!legacyRevealMode || !["normal", "initials", "wordByWord", "underline"].includes(legacyRevealMode)) document.settings.revealMode = "normal";
  const voiceReading = (document.settings.voiceReading ?? {}) as Partial<ScriptDocument["settings"]["voiceReading"]>;
  document.settings.voiceReading = {
    readOthersLines: voiceReading.readOthersLines ?? true,
    readMyLines: voiceReading.readMyLines ?? false,
    autoProceed: voiceReading.autoProceed ?? false,
    speed: voiceReading.speed ?? defaults.defaultPlaybackSpeed,
    pitch: voiceReading.pitch ?? 1,
    volume: voiceReading.volume ?? 1,
    language: voiceReading.language ?? defaults.defaultLanguage,
  };
  document.settings.recognition ??= {
    threshold: defaults.recognitionThreshold,
    ignoredWords: [...defaults.ignoredWords],
  };
  return document;
}

export function applyImportDefaults(document: ScriptDocument, defaults: AppSettings): void {
  document.settings.voiceReading.speed = defaults.defaultPlaybackSpeed;
  document.settings.voiceReading.language = defaults.defaultLanguage;
  document.settings.recognition = {
    threshold: defaults.recognitionThreshold,
    ignoredWords: [...defaults.ignoredWords],
  };
}

export function parseCommaSeparated(value: string): string[] {
  return [...new Set(value.split(",").map((item) => item.trim()).filter(Boolean))];
}

export function parseWordList(value: string): string[] {
  return parseCommaSeparated(value.toLowerCase());
}
